import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-temporary-password-result',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
  ],
  template: `
    <h2 mat-dialog-title>Contraseña temporal generada</h2>

    <mat-dialog-content>
      <p>
        La contraseña temporal para el usuario 
        <b>{{ data.username }}</b> es:
      </p>

      <br>

      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Contraseña temporal</mat-label>
        <input matInput [value]="data.plainPassword" readonly #passwordInput />
        <button
          mat-icon-button
          matSuffix
          (click)="copyToClipboard(passwordInput.value)"
          [disabled]="copied"
          [matTooltip]="copied ? 'Copiado' : 'Copiar contraseña'"
        >
          <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
        </button>
      </mat-form-field>

      <p class="mt-2">
        <b>Expira el: </b> {{ data.expiresAt | date:'short' }}
      </p>

      <p class="text-red-600 font-semibold mt-2">
        Asegúrese de copiar la contraseña antes de cerrar este diálogo.
      </p>      
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button (click)="close()">Cerrar</button>
    </mat-dialog-actions>
  `
})
export class TemporaryPasswordResultComponent {
  copied = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { username: string; plainPassword: string; expiresAt: string | Date },
    private dialogRef: MatDialogRef<TemporaryPasswordResultComponent>
  ) {}

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text).then(() => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}

